import deepmerge from 'deepmerge'
import { arrayOf, bool, func, node, shape, string } from 'prop-types'

import { DEBUG_KEY } from 'shared/store/helper/consts'
import withStore from 'views/enhancers/withStore'

const AsyncDataFetcher = ({
  store,
  autofetch,
  api,
  apiCall,
  fallback,
  setContent,
  callOptions: givenCallOptions,
  publishTopic,
  children,
  callOnTopic,
  lazyLoad,
  className,
}) => {
  const callOptions = deepmerge(
    givenCallOptions,
    store.getState()[DEBUG_KEY] ? { params: { [DEBUG_KEY]: 1 } } : {}
  )
  return (
    <div
      data-clientside-autofetch={autofetch}
      data-clientside-fallback={fallback}
      data-clientside-api={api}
      data-clientside-api-call={apiCall}
      data-clientside-call-options={JSON.stringify(callOptions)}
      data-clientside-set-content={setContent}
      data-clientside-publish-topic={publishTopic}
      data-clientside-call-on-topic={callOnTopic}
      data-clientside-lazyload={lazyLoad}
      className={className}
    >
      {children}
    </div>
  )
}

AsyncDataFetcher.propTypes = {
  store: shape({ getState: func.isRequired }).isRequired,
  children: node,
  autofetch: bool,
  fallback: string,
  setContent: bool,
  publishTopic: arrayOf(shape),
  callOptions: shape({}),
  api: string,
  callOnTopic: string,
  apiCall: string.isRequired,
  lazyLoad: bool,
  className: string,
}

AsyncDataFetcher.defaultProps = {
  api: 'bully',
  fallback: '',
  setContent: true,
  publishTopic: null,
  callOptions: {},
  children: null,
  autofetch: false,
  callOnTopic: null,
  lazyLoad: false,
  className: null,
}

export default withStore(AsyncDataFetcher)
